var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.64 14.903c-1.602 6.428-8.114 10.34-14.544 8.738C2.669 22.038-1.244 15.527.359 9.098 1.962 2.67 8.473-1.244 14.902.36c6.43 1.603 10.342 8.115 8.739 14.544Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.28 10.305c.238-1.597-.978-2.456-2.64-3.028l.539-2.163-1.317-.328-.525 2.106a55.097 55.097 0 0 0-1.055-.249l.529-2.12-1.316-.328-.54 2.163c-.286-.066-.568-.13-.84-.198v-.007L8.3 5.7l-.35 1.406s.977.224.956.238c.533.133.63.486.614.766l-1.478 5.925c-.065.162-.23.405-.604.313.014.019-.957-.24-.957-.24l-.653 1.508 1.713.427c.319.08.631.164.939.242l-.545 2.188 1.315.328.54-2.164c.36.097.708.187 1.05.272l-.538 2.154 1.316.328.545-2.183c2.245.425 3.934.253 4.645-1.777.572-1.635-.029-2.578-1.21-3.193.86-.199 1.508-.765 1.681-1.933Zm-3.01 4.218c-.406 1.635-3.16.75-4.052.53l.723-2.899c.893.223 3.755.664 3.33 2.369Zm.408-4.242c-.372 1.487-2.663.731-3.406.546l.655-2.628c.744.185 3.138.53 2.75 2.082Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcb);
export default __webpack_public_path__ + "static/media/btcb.7114cfc3f13dfce18df877255acb71eb.svg";
export { ForwardRef as ReactComponent };